<template>
  <div class="customSelectGroup">

    <span v-if="label">
      <h6 :class="$style.label">{{ label }}</h6>
      <app-tooltip v-if="tooltip">
            <template v-slot:tooltipHeader>
              <slot name="tooltipHeader" />
            </template>
            <template v-slot:tooltipText>
              <slot name="tooltipText" />
            </template>
        </app-tooltip>
    </span>

    <v-select append-icon=""
              :items="items"
              :value="value"
              :disabled="disabled"
              @change="onChange($event)">
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="scss" module>
.label {
  display: inline-block;
  position: relative;
  top: 7px;
  line-height: 2.1rem;
  margin-bottom: 12px;
  white-space: nowrap;
}
</style>

<style lang="scss">
@import "@/styles/variables.scss";

.customSelectGroup {

    .v-text-field__details {
      display: none;
    }

    .v-text-field >.v-input__control>.v-input__slot {

      .v-select__slot {
        display: block;

        label.v-label,
        label.v-label--active {
          display: inline-block;
          position: relative !important;
          font-family: $title-font;
          color: $main-text-color !important;
          font-size: 1.6rem;
          line-height: 2.1rem;
          font-weight: 700;
          font-style: italic;
          height: auto;
          margin-bottom: 12px;
          transform: none;
          pointer-events: auto;
          overflow: visible;
        }

        .v-select__selections {
          border:1px solid $field-borders-color;
          border-radius: 2px;
          max-height: none;
          padding: 3px 10px;
          background-image: url('../../../assets/img/arrow drop down.png');
          background-repeat: no-repeat;
          background-size: 10px;
          background-position: right 10px center;
          input {
            margin-bottom: 0;
          }
        }
      }

      &::before,
      &::after {
        content: none;
      }
    }
}
</style>
